<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content>
    <div class="modal-container">
        <h2>Please provide a reason to refuse this request</h2>
        <br/>
        <div fxLayout="row" fxLayoutAlign="center">
            <mat-card>
                <mat-card-content>
                    <table class="top-tables">
                        <div *ngIf="selectedData.tag=='workabroad'">
                            <tr>
                                <th id="name" class="top-table-headings">Employee Name</th>
                                <td>{{selectedData.value.firstName}} {{selectedData.value.lastName}}</td>
                            </tr>
                            <tr>
                                <th id="country" class="top-table-headings">Work Abroad Country</th>
                                <td>{{selectedData.value.country}}</td>
                            </tr>
                            <tr>
                                <th id="startDate" class="top-table-headings">Work Abroad Start Date</th>
                                <td>{{selectedData.value.startDate}}</td>
                            </tr>
                            <tr>
                                <th id="endDate" class="top-table-headings">Work Abroad End Date</th>
                                <td>{{selectedData.value.endDate}}</td>
                            </tr>
                            <tr>
                                <th id="work-abroad-days" class="top-table-headings">Work Abroad Days</th>
                                <td>{{selectedData.value.numberOfWorkAbroadDays}}</td>
                            </tr>
                            <tr>
                                <th id="annualLeaveDays" class="top-table-headings">Annual Leave Days</th>
                                <td>{{selectedData.value.numberOfAnnualLeaveDays}}</td>
                            </tr>
                            <tr *ngIf="selectedData.value.vacations.length>0">
                                <th id="work-abroad-type" class="top-table-headings">Absence Type</th>
                                <td>{{selectedData.value.vacations[0].absenceType}}</td>
                            </tr>
                            <tr *ngIf="selectedData.value.vacations.length>0">
                                <th id="absenceReason" class="top-table-headings">Absence Reason</th>
                                <td>{{selectedData.value.vacations[0].absenceReason}}</td>
                            </tr>
                        </div>
                    </table>
                    <table class="top-tables">
                        <div *ngIf="selectedData.tag=='personal'">
                            <tr>
                                <th id="vacation name" class="top-table-headings">Employee Name</th>
                                <td>{{selectedData.value.firstName}} {{selectedData.value.lastName}}</td>
                            </tr>
                            <tr>
                                <th id="vacation" class="top-table-headings">Absence Type</th>
                                <td>{{selectedData.value.absenceType}}</td>
                            </tr>
                            <tr>
                                <th id="vacation absenceReason" class="top-table-headings">Absence Reason</th>
                                <td>{{selectedData.value.absenceReason}}</td>
                            </tr>
                            <tr>
                                <th id="vacation startDate" class="top-table-headings">Vacation Start Date</th>
                                <td>{{selectedData.value.startDate}}</td>
                            </tr>
                            <tr>
                                <th id="vacation endDate" class="top-table-headings">Vacation End Date</th>
                                <td>{{selectedData.value.endDate}}</td>
                            </tr>
                            <tr>
                                <th id="vacation annualLeaveDays" class="top-table-headings">Annual Leave Days</th>
                                <td>{{selectedData.value.numberOfAnnualLeaveDays}}</td>
                            </tr>
                        </div>
                    </table>
                </mat-card-content>
            </mat-card>

        </div>
        <br/>
        <div>
            <p class="cancel-request-info">*By declining this request, the employee's holiday will NOT be
                cancelled.</p>
            <p class="cancel-request-info">If you approve the request, the employee's holiday will be
                cancelled,</p>
            <p class="cancel-request-info">and their holiday allowance will be given back.</p>
        </div>
        <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="12">
            <form fxLayout="column" fxLayoutAlign="center" #form="ngForm">
                <mat-form-field>
                    <mat-label>Leave a comment</mat-label>
                    <textarea matInput required id="managerComment" [(ngModel)]="vacation.managerComment"
                              name="managerComment" [value]="vacation.managerComment" minlength="8" [maxlength]="499">
                    </textarea>
                </mat-form-field>
                <br/>
                <button mat-raised-button color="primary"
                        (click)="approveOrDeclineCancelRequest(this.vacation,'DECLINE',this.typeOfRequest)" [disabled]="!form.form.valid">Decline
                </button>
                <br/>
                <button mat-raised-button color="primary"
                        (click)="approveOrDeclineCancelRequest(this.vacation,'APPROVE',this.typeOfRequest)">Approve
                </button>
            </form>
        </div>
    </div>
</mat-dialog-content>
